const escapeCsv = (value) => {
  const str = value == null ? "" : String(value);
  if (/[",\n\r]/.test(str)) return `"${str.replace(/"/g, '""')}"`;
  return str;
};

const getCustomerName = (order) => {
  const fromUser = [order.user?.first_name, order.user?.last_name].filter(Boolean).join(" ");
  return fromUser || order.shippingAddress?.full_name || "Guest";
};

export const exportOrdersCsv = (orders, filename = "stex-orders.csv") => {
  if (!orders?.length) return false;

  const headers = [
    "Order Number",
    "Date",
    "Customer",
    "Email",
    "Phone",
    "Status",
    "Payment Status",
    "Payment Method",
    "Total (NGN)",
    "Shipping City",
    "Shipping State",
  ];

  const rows = orders.map((order) => [
    order.orderNumber,
    new Date(order.createdAt).toISOString(),
    getCustomerName(order),
    order.user?.email || order.shippingAddress?.email || "",
    order.shippingAddress?.phone_number || "",
    order.status,
    order.paymentStatus,
    order.paymentDetails?.paymentMethod || "",
    order.totalAmount,
    order.shippingAddress?.city || "",
    order.shippingAddress?.state || "",
  ]);

  const csv = [headers, ...rows].map((row) => row.map(escapeCsv).join(",")).join("\r\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
  return true;
};
